export default __webpack_public_path__ + "static/media/CIS-gallery-3-M-soleplate.1e6adad0.jpg";